module.exports = __webpack_public_path__ + "static/media/WalkUpToggleLandingScreen.3b6028de.png";